module.exports = __webpack_public_path__ + "static/movie_poster_with_logo-min.0b4ef55d.png";